import { render, staticRenderFns } from "./LandingPresentationAlpha.vue?vue&type=template&id=3f91019a&scoped=true&"
import script from "./LandingPresentationAlpha.vue?vue&type=script&lang=ts&"
export * from "./LandingPresentationAlpha.vue?vue&type=script&lang=ts&"
import style0 from "./LandingPresentationAlpha.vue?vue&type=style&index=0&id=3f91019a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f91019a",
  null
  
)

export default component.exports